module.exports = __webpack_public_path__ + "static/ru-1-7772533b5c7d42914fcd07d592193ade.png";